import clsx from "clsx";
import { FC } from "react";

export interface ProgressStepperProps {
  steps: number;
  currentStep: number;
  initialPercentage?: number;
  className?: string;
}

const ProgressStepper: FC<ProgressStepperProps> = ({
  steps,
  initialPercentage,
  currentStep,
  className,
}) => {
  steps = steps ?? currentStep + 1;
  const percentage = (100 / steps) * currentStep;
  const progressStyle: {
    width: string;
    minWidth?: string;
  } = {
    width: `${percentage}%`,
  };
  if (initialPercentage || initialPercentage === 0) {
    progressStyle.minWidth = `${initialPercentage}%`;
  }
  return (
    <div className={clsx("bg-neutral-25 rounded-xs", className)}>
      <div
        className="duration-500 h-[6px] min-w-[5%] max-w-full bg-primary-800 rounded-xs transition-all"
        data-testid="progress-bar"
        style={progressStyle}
      />
    </div>
  );
};

export default ProgressStepper;
